<template lang="pug">
  v-btn-toggle(
    v-model="model"
    class="yes-no-switch"
    dense
    rounded
    tile
  )
    v-btn(
      depressed
      :value="trueValue"
      x-small
    ) {{ trueLabel }}
    v-btn(
      depressed
      :value="falseValue"
      x-small
    ) {{ falseLabel }}
</template>

<script>
export default {
  name: 'EYesNoSwitch',
  model: { prop: 'value', event: 'input' },
  props: {
    value: {
      type: [String, null],
      default: null
    },
    trueValue: {
      type: String,
      default: 'yes'
    },
    falseValue: {
      type: String,
      default: 'no'
    },
    trueLabel: {
      type: String,
      default: 'Так'
    },
    falseLabel: {
      type: String,
      default: 'Ні'
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.yes-no-switch {
  width: 83px;
  max-width: 83px;
  height: 32px;
  border-radius: 8px;
  .v-btn {
    height: 100%;
    max-width: 100%;
    &.v-btn--active {
      background: $primary;
      color: #fff;
    }
  }
}
</style>
